import { render, staticRenderFns } from "./AuthResetForm.vue?vue&type=template&id=4e830567&scoped=true&lang=pug&"
import script from "./AuthResetForm.vue?vue&type=script&lang=js&"
export * from "./AuthResetForm.vue?vue&type=script&lang=js&"
import style0 from "./AuthResetForm.vue?vue&type=style&index=0&id=4e830567&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e830567",
  null
  
)

export default component.exports